<template>
  <span class="main-tab-menu select-none">
    <i :class="contextItem.icon ? contextItem.icon : 'iconfont icon-tag'"></i>
    <span class="menu-text">{{contextItem.label}}</span>
    <span class="event-trigger" @dblclick.stop="handleDblclick"></span>
  </span>
</template>

<script>
export default {
  name: 'MainContextMenu',
  props: {
    contextItem: {
      type: Object,
      required: true
    }
  },
  methods: {
    handleDblclick () {
      this.$emit('handleRefresh')
    }
  }
}
</script>

<style lang="scss">
  .main-tab-menu {
    .event-trigger {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
    }
  }
</style>
